// extracted by mini-css-extract-plugin
export default {"pdfLogo":"studentprofile_2_pdfLogo__Ow5wL"};